import StatisticsCostLimit from '@/modules/statisticsCostLimit/view/StatisticsCostLimitView.vue';

export const StatisticsCostLimitRoutes = [
  {
    path: '/statistics/costlimit',
    name: 'StatisticsCostLimit',
    component: StatisticsCostLimit,
  },
];

